export const mockData = {
  mission: {
    description: "takeatrip nyc is an events & excursions platform designed for early-career professionals in white-collar industries. Driven by our mission to close access gaps in popular industry hobbies & activities that are often financially or socially out of reach, we curate beginner-friendly, community-first experiences across ski trips, adventure and leisure travel, and more.",
    goal: "Join a growing community in NYC to connect with people with similar cultural backgrounds and professional ambitions, organically grow your network, and try something new that you just might like."
  },
  events: [
    {
      id: 1,
      name: "Winter Wonderland:\nSlope Social Kickoff",
      date: "November 8th, 2025",
      location: "Brooklyn, NY",
      description: "Join us for the official launch and pre-trip party for Slope Social I! Meet fellow adventurers, learn about the upcoming trip, and celebrate the beginning of something incredible. Vibes powered by our friends at Somewhere Social",
      status: "On Sale",
      type: "launch"
    },
    {
      id: 2,
      name: "Slope Social I: All-In Ski Weekend",
      date: "January 30 - February 1, 2026",
      location: "Lehigh Valley, PA",
      description: "Our maiden ski & snowboarding weekend! Perfect for beginners and experienced skiers alike, with one price for all your needs.",
      status: "On Sale", 
      type: "ski"
    }
  ],
  stats: {
    members: "1000+",
    destinations: "12+",
    experiences: "25+"
  },
  faqs: [
    {
      question: "Why takeatrip NYC?",
      answer: "No-hassle trips and experiences designed with beginners & first-timers in mind. One package for all of your needs. A year-round calendar of curated excursions, events, and experiences from NYC to wherever. A community of authentic, real people with shared culture and ambitions. All travelers are required to be 21+ to participate."
    },
    {
      question: "What's included in the trip cost?",
      answer: "For one price, your trip will include transportation to and from the resort from NYC, ski / snowboard equipment rentals, lift tickets, a beginner lesson, group snow tubing, Après-ski admission (post-ski party), 3 group meals, 3 days & 2 nights luxury resort stay with access to amenities (heated pool, hot tub, spa, etc.), plenty of photo ops, and great vibes :)"
    },
    {
      question: "What do I need to bring?",
      answer: "While we do take care of almost everything you need, you will need to bring your personal items, travel necessities, and winter-appropriate clothing (jackets, hats, glove, etc.). We'll be sure to send around a recommended gear list & style lookbook before the trip!"
    },
    {
      question: "Are these trips beginner-friendly?",
      answer: "Absolutely! Whether you're trying a new activity for the first time or are more seasoned, our trips are designed to be inclusive and welcoming for all experience levels."
    },
    {
      question: "How early should I book?",
      answer: "We recommend signing up early to secure your spot, as trips will fill up fast, especially during peak winter season."
    },
    {
      question: "Is skiing expensive?",
      answer: "Ski trips can get pricey, but don't worry! We've put together a sweet package that keeps things affordable and accessible for everyone. Think of it as luxury vibes without the luxury price tag."
    },
    {
      question: "Can I invite a friend?",
      answer: "Totally! Bring your friends, roommates, or whoever you want to share the good times with. If you're coming solo, be prepared to leave in a new group chat!"
    },
    {
      question: "I'm not based in NYC. Can I still join?",
      answer: "100%! No matter where you're from, you're welcome to join the fun. Just check the trip details for all important travel info."
    },
    {
      question: "Is transportation to the resort included?",
      answer: "Yes, transportation to and from the resort via luxury coach bus is part of the trip package."
    },
    {
      question: "Can I bring my own ski equipment?",
      answer: "Absolutely! If you have your own gear, feel free to bring it. Please note that equipment rentals are included in all packages, regardless of whether you bring your own or not."
    },
    {
      question: "How can I get involved beyond the trips?",
      answer: "Follow us on social media and sign up for our email list to stay in the loop on all future events, hangouts, and more happening all year long."
    }
  ]
};